import { deleteRequest, getRequest, postRequest, putRequest } from './common'

const URL_BASE = '/api/v1/console/'

export function getNotes(parentName: string, parentId: string) {
  const url = `${URL_BASE}${parentName}/${parentId}/notes/`
  return getRequest(url)
}

export function createNote(parentName: string, parentId: string, text: string) {
  const url = `${URL_BASE}${parentName}/${parentId}/notes/`

  const payload = {
    text: text,
  }
  return postRequest(url, payload)
}

export function updateNote(parentName: string, parentId: string, text: string, noteId: string) {
  const url = `${URL_BASE}${parentName}/${parentId}/notes/${noteId}/`

  const payload = {
    text: text,
  }
  return putRequest(url, payload)
}

export function deleteNote(parentName: string, parentId: string, noteId: string) {
  const url = `${URL_BASE}${parentName}/${parentId}/notes/${noteId}/`

  return deleteRequest(url)
}
